module.exports = __webpack_public_path__ + "img/platform-peitu.fbf3773a.png";